import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { WR } from "../../../components/ui/tokens";

const MENU_WIDTH = 240;

// Minimal custom context menu anchored at the pointer. One entry for now.
// Closes on outside pointerdown, Escape or scroll.
const ProductContextMenu = ({ position, onEdit, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("pointerdown", onClose);
    window.addEventListener("keydown", onKey);
    window.addEventListener("scroll", onClose, true);
    return () => {
      window.removeEventListener("pointerdown", onClose);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", onClose, true);
    };
  }, [onClose]);

  const left = Math.max(8, Math.min(position.x, window.innerWidth - MENU_WIDTH - 8));
  const top = Math.max(8, Math.min(position.y, window.innerHeight - 72));

  return (
    <div
      role="menu"
      onPointerDown={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.preventDefault()}
      style={{
        position: "fixed",
        top,
        left,
        width: MENU_WIDTH,
        zIndex: 1000,
        background: WR.color.surface,
        border: `1px solid ${WR.color.border}`,
        borderRadius: WR.radius.md,
        boxShadow: WR.shadow.card,
        padding: 6,
        fontFamily: WR.font.sans,
      }}
    >
      <button
        type="button"
        role="menuitem"
        onClick={onEdit}
        style={{
          width: "100%",
          textAlign: "left",
          border: 0,
          background: "transparent",
          padding: "10px 12px",
          borderRadius: WR.radius.sm,
          fontSize: WR.text.body,
          fontWeight: WR.weight.bold,
          color: WR.color.encre,
          cursor: "pointer",
        }}
      >
        {t("LAYOUT_EDIT")}
      </button>
    </div>
  );
};

export default ProductContextMenu;
